import { AlertController, NavController, ToastController } from 'ionic-angular';
import { ActionSheetController } from 'ionic-angular';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { AuthProvider } from '../../providers/auth/auth';
import { Device, User } from '../../models/models';
import { DeviceProvider } from '../../providers/device/device';
import { DeviceShowPage } from '../../pages/device-show/device-show';
import { DeviceEditPage } from '../../pages/device-edit/device-edit';


/**
* Generated class for the DeviceItemComponent component.
*
* See https://angular.io/api/core/Component for more info on Angular
* Components.
*/
@Component({
	selector: 'device-item',
	templateUrl: 'device-item.html'
})
export class DeviceItemComponent {
	@Output() refresh: EventEmitter<Device> = new EventEmitter<Device>();

	private _device: Device;
	/**
	Eventuale utente di cui si visualizza il dispositivo
	*/
	@Input() public user: User;

	constructor(
		public actionSheetCtrl: ActionSheetController,
		public alertCtrl: AlertController,
		public auth: AuthProvider,
		public nav: NavController,
		public toastCtrl: ToastController,
		public devices: DeviceProvider,
	) {
	}


	@Input() public set device(device: Device) {
		this._device = device;
		console.log('DeviceItem, device:', device);
	}

	public get device() {
		return this._device;
	}

	goToDeviceEdit() {
		this.nav.push(DeviceEditPage, { device: this.device });
	}

	goToDeviceShow() {
		this.nav.push(DeviceShowPage, { device: this.device });
	}

	showMenu() {
		let self = this;
		let buttons = [];
		if (this.auth.canDeviceShow(this.device)) {
			buttons.push({
				text: 'Visualizza',
				icon: 'eye',
				handler: () => {
					self.goToDeviceShow();
				}
			});
		}

		if (this.auth.canDeviceEdit(this.device)) {
			buttons.push({
				text: 'Modifica',
				role: 'destructive',
				icon: 'create',
				handler: () => {
					self.goToDeviceEdit();
				}
			});

			if (this.device.condominium) {
				buttons.push({
					text: 'Rimuovi dal condominio',
					role: 'destructive',
					icon: 'remove',
					handler: () => {
						self.showRemoveCondominiumConfirm();
					}
				});
			}
		}

		if (this.auth.canDeviceDelete(this.device)) {
			buttons.push({
				text: 'Elimina',
				role: 'destructive',
				icon: 'trash',
				handler: () => {
					self.showDestroyDeviceConfirm();
				}
			});
		}
		buttons.push({
			text: 'Annulla',
			role: 'cancel',
			icon: 'undo',
			handler: () => { }
		});

		let options = {
			title: 'Dispositivo "' + this.device.name + '"',
			subTitle: 'UID: ' + this.device.identifier,
			buttons: buttons
		};

		let actionSheet = this.actionSheetCtrl.create(options);
		actionSheet.present();
	}

	showDestroyDeviceConfirm(closable: any = null) {
		if (closable) {
			closable.close();
		}
		let self = this;
		let device = this.device;

		let confirm = this.alertCtrl.create({
			title: "Eliminare la configurazione del dispositivo dal server?",
			message: "Vuoi davvero eliminare la configurazione del dispositivo " + device.name + " " + device.identifier + "?",
			buttons: [
				{
					text: 'Annulla',
					role: 'cancel'
				}, {
					text: 'Elimina',
					handler: () => {
						self.devices.destroy(device).then((success: boolean) => {
							if (success) {
								let toast = self.toastCtrl.create({
									message: 'Dispositivo eliminato',
									position: 'middle',
									duration: 3000,
									cssClass: "light"
								});
								toast.present();
							} else {
								let toast = self.toastCtrl.create({
									message: "Potrebbe essersi verificato un errore eliminando il dispositivo",
									position: 'middle',
									duration: 3000,
									cssClass: "danger"
								});
								toast.present();
							}
							self.refresh.emit(device);
						}).catch(error => {
							console.error("Errore eliminando il dispositivo", error);
							let toast = self.toastCtrl.create({
								message: "Errore eliminando il dispositivo",
								position: 'middle',
								duration: 3000,
								cssClass: "danger"
							});
							toast.present();
							self.refresh.emit(device);
						});
					}
				}
			]
		});
		confirm.present();
	}


	showRemoveCondominiumConfirm() {
		if (!this.device) {
			console.error("Dispositivo non specificato per device-item");
			return;
		}
		if (!this.device.condominium) {
			console.error("Dispositivo non associato al condominio");
			return;
		}
		let self = this;
		let device = this.device;
		let condominium = this.device.condominium;

		let alertConfirm = this.alertCtrl.create({
			title: 'Rimuovi dispositivo dal condominio',
			message: "Si vuole veramente rimuovere il dispositivo '" + self.device.name + "' " + self.device.identifier + " dal condominio '" + condominium.name + "'?",
			buttons: [{
				text: 'Annulla',
				role: 'cancel',
				handler: () => { }
			}, {
				text: 'Conferma',
				handler: () => {
					self.device.condominium_id = null;
					self.device.condominium = null;
					self.devices.update(self.device)
						.then((result: Device) => {
							self.refresh.emit(device);
							if (result) {
								let toast = self.toastCtrl.create({
									message: "Dispositivo '" + self.device.name + "' " + self.device.identifier + " rimosso dal condominio '" + condominium.name,
									position: 'middle',
									duration: 3000,
									cssClass: "light"
								});
								toast.present();
							} else {
								let toast = self.toastCtrl.create({
									message: "Potrebbe essersi verificato un errore rimuovendo il dispositivo '" + self.device.name + "' " + self.device.identifier + " dal condominio '" + condominium.name,
									position: 'middle',
									duration: 3000,
									cssClass: "danger"
								});
								toast.present();
							}
						}).catch((error: any) => {
							console.error('Errore rimuovendo il dispositivo dal condominio:', error);
							self.refresh.emit(device);
							let toast = self.toastCtrl.create({
								message: "Errore rimuovendo il dispositivo '" + self.device.name + "' " + self.device.identifier + " dal condominio '" + condominium.name,
								position: 'middle',
								duration: 3000,
								cssClass: "danger"
							});
							toast.present();
						});
				}
			}]
		});
		alertConfirm.present();
	}
}



// WEBPACK FOOTER //
// ./src/components/device-item/device-item.ts